import type { RecipeIngredient } from '@/types/recipe'

export function formatIngredientsForClipboard(ingredients: RecipeIngredient[]): string {
  return ingredients
    .map((ing) => {
      const parts = [ing.quantity, ing.unit, ing.name].filter(Boolean)
      return `• ${parts.join(' ')}`
    })
    .join('\n')
}
